import { css } from "@emotion/react";

// TODO: add tablet and mobile styles
export const typography = {
    Display1: css`
        font-size: 96px;
        font-style: normal;
        font-weight: 700;
        line-height: 96px;
        text-transform: uppercase;
    `,
    Display2: css`
        font-size: 60px;
        font-style: normal;
        font-weight: 700;
        line-height: 64px;
        text-transform: uppercase;
    `,
    Title1: css`
        font-size: 48px;
        font-style: normal;
        font-weight: 700;
        line-height: 52px;
    `,
    Title2: css`
        font-size: 40px;
        font-style: normal;
        font-weight: 700;
        line-height: 44px;
    `,
    Title3: css`
        font-size: 32px;
        font-style: normal;
        font-weight: 700;
        line-height: 36px;
    `,
    Title4: css`
        font-size: 26px;
        font-style: normal;
        font-weight: 700;
        line-height: 32px;
    `,
    Title5: css`
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: 24px;
    `,
    "Body/Regular/Text1": css`
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 28px;
    `,
    "Body/Regular/Text2": css`
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
    `,
    "Body/Regular/Text3": css`
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
    `,
    "Body/Bold/Text1": css`
        font-size: 18px;
        font-style: normal;
        font-weight: 700;
        line-height: 28px;
    `,
    "Body/Bold/Text2": css`
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 24px;
    `,
    "Body/Bold/Text3": css`
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 20px;
    `,
    "Caption/Regular/Caption1": css`
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 16px;
    `,
    "Caption/Bold/Caption1": css`
        font-size: 12px;
        font-style: normal;
        font-weight: 700;
        line-height: 16px;
    `,
};
